import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import utilities from '../../utils';
import {Col, Row} from "react-bootstrap";

export default function ScheduledSpotConfirmationModal({ show, onCancel, onConfirm, model }) {
    const { t } = useTranslation();
    const [actionInProgress, setActionInProgress] = useState(false);
    const { formatDate, formatAmount } = utilities.format;

    // Reset actionInProgress when modal is shown/hidden
    useEffect(() => {
        if (show) {
            setActionInProgress(false);
        }
    }, [show]);

    const handleCancel = () => {
        if (!actionInProgress) {
            setActionInProgress(true);
            onCancel();
        }
    };

    const handleConfirm = () => {
        if (!actionInProgress) {
            setActionInProgress(true);
            onConfirm();
        }
    };

    function formatValueDate() {
        if (model.valueDateDate) {
            return (
                <>
                    <Row className="display-6 mb-2">
                        <Col xs={12} sm={3} md={3}>
                            {t('td.fx.ticket.label.ValueDate')}
                        </Col>
                        <Col xs={12} sm={6} md={4} style={{textAlign: 'left'}}>
                            {formatDate(model.valueDateDate)}
                        </Col>
                    </Row>
                </>
            );
        } else {
            return '';
        }
    }

    function getBuySell() {
        if (model.buyAmount !== '') {
            return (
                <>
                    <Row className="display-6 mb-2">
                        <Col xs={12} sm={3} md={3}>
                            {t('td.fx.ticket.modal.buying')}
                        </Col>
                        <Col xs={12} sm={6} md={4} style={{textAlign: 'left'}}>
                            {formatAmount(model.buyAmount)} {model.buyCurrency}
                        </Col>
                    </Row>
                    <Row className="display-6 mb-2">
                        <Col xs={12} sm={3} md={3}>
                            {t('td.fx.ticket.modal.selling')}
                        </Col>
                        <Col xs={12} sm={6} md={4} style={{textAlign: 'left'}}>
                            {model.sellCurrency}
                        </Col>
                    </Row>
                </>
            );
        } else if (model.sellAmount !== '') {
            return (
                <>
                    <Row className="display-6 mb-2">
                        <Col xs={12} sm={3} md={3}>
                            {t('td.fx.ticket.modal.selling')}
                        </Col>
                        <Col xs={12} sm={6} md={4} style={{textAlign: 'left'}}>
                            {formatAmount(model.sellAmount)} {model.sellCurrency}
                        </Col>
                    </Row>
                    <Row className="display-6 mb-2">
                        <Col xs={12} sm={3} md={3}>
                            {t('td.fx.ticket.modal.buying')}
                        </Col>
                        <Col xs={12} sm={6} md={4} style={{textAlign: 'left'}}>
                            {model.buyCurrency}
                        </Col>
                    </Row>
                </>
            );

        }
    }

    return (
        <Modal show={show} onHide={handleCancel} centered className="td-modal modal-lg">
            <Modal.Header>
                <Modal.Title><h2>{t('td.fx.ticket.scheduledspot.confirm.title')}</h2></Modal.Title>
            </Modal.Header>
            <Modal.Body className="td-modal-body-shown">
                <p>{t('td.fx.ticket.scheduledspot.confirm.message')}</p>
                {formatValueDate()}
                {getBuySell()}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn td-btn-secondary-clear"
                    onClick={handleCancel}
                    disabled={actionInProgress}
                >
                    {t('td.fx.ticket.scheduledspot.cancel')}
                </Button>
                <Button
                    className="btn td-btn-primary-light"
                    onClick={handleConfirm}
                    disabled={actionInProgress}
                >
                    {t('td.fx.ticket.scheduledspot.schedule')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
